// # 공유 시트로 들어온 글
//
// 다른 앱의 "공유" 에서 마루를 고르면 설치된 웹 앱(PWA)이 `/share?title=&text=&url=` 로
// 열린다(Web Share Target, `manifest.webmanifest` 의 `share_target`). 안드로이드 크롬과
// 데스크톱 크롬 계열에서 설치한 앱이 공유 대상에 선다. 슬랙 모바일의 공유 확장과 같은 자리다.
//
// ## 곧장 보내지 않는다
// 들어온 글은 **고른 채널의 입력칸에 초안으로** 넣는다. 공유 시트는 누르는 손이 가볍다 —
// 잘못 고른 채널에 링크 하나가 그대로 올라가면 되돌릴 수 없다. 사람이 한 번 보고 보낸다.
//
// ## 파일은 아직이다
// 파일을 받으려면 `POST` + 서비스 워커가 몸통을 받아 쥐고 있어야 한다. 글·주소만 먼저 한다.

/** `share_target.action` 과 같아야 한다(`share.test.ts` 가 맞댄다). */
export const SHARE_PATH = '/share'

/** 주소창에서 공유된 글을 꺼낸다. 아니면 `null`. 셋을 한 덩어리로 이어 붙인다. */
export function share_in(loc: { pathname: string; search: string } | undefined): string | null {
  if (loc === undefined || loc.pathname !== SHARE_PATH) return null
  const q = new URLSearchParams(loc.search)
  const parts: string[] = []
  for (const key of ['title', 'text', 'url']) {
    const v = q.get(key)?.trim()
    // 안드로이드는 주소를 `text` 에 싣고 `url` 을 비우기도, 둘 다에 싣기도 한다. 같은 줄은 한 번만.
    if (v && !parts.includes(v)) parts.push(v)
  }
  const joined = parts.join('\n')
  return joined === '' ? null : joined
}
